import React, { Fragment, useState } from "react";
import {
  Badge,
  Button,
  Col,
  Input,
  InputGroup,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import AddAssign from "./AddAssign";
import EditData from "../officer/EditData";
import LoadingData from "../../TESTPage/LoadingData";
import FadeIn from "react-fade-in/lib/FadeIn";
import { useEffect } from "react";
import { GetCookieToken } from "../../Cookie/GetCookie";
import axios from "axios";
import dayjs from "dayjs";
import EditAssign from "./EditAssign";
import EditAssignCommander from "./EditAssignCommander";
import ConfirmModal from "../../../components/Common/ConfirmModal";
import { useNavigate } from "react-router-dom";
import { CheckPosition } from "../../Function/CheckPosition";
import { CheckSubAdmin } from "../../Function/CheckSubAdmin";

const API_URL = process.env.REACT_APP_API_CORS;

function AssignCommander(props) {
  const { userInfo } = props;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [userAssignData, setUserAssignData] = useState([]);
  const [dataInfo, setDataInfo] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [keyword, setKeyword] = useState("");
  const [pushkeyword, setPushKeyword] = useState("");

  const [confirmModal, setconfirmModal] = useState(false);
  const [id, setId] = useState();

  const token = GetCookieToken("userToken");

  const [inversedSort, setInversedSort] = useState(false);
  const [indexSort, setIndexSort] = useState(3);

  const fetchUserData = async (orderBy = "position_id", sortedBy = "ASC") => {
    const url = `${API_URL}/api/users/position/datatable`;
    const params = new URLSearchParams({
      page: currentPage,
      size: 10,
      "order[0]": orderBy,
      "order[1]": sortedBy,
      search: pushkeyword,
      "filter[assign][0]": "1",
    });
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      params,
    };
    try {
      const response = await axios.get(url, config);
      setUserAssignData(response.data.result);
      setDataInfo(() => response.data.info);
      setTotalPages(Math.ceil(response.data.info.totalRows / pageSize));
    } catch (error) {
      console.error("fetchUserData Error:", error);
    }
  };

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      await fetchUserData();
      setLoading(false);
    };
    load();
  }, [currentPage, pageSize, pushkeyword]);

  const handleSearch = () => {
    setPushKeyword(() => keyword);
  };

  const handleButtonClick = async () => {
    setLoading(true);
    await fetchUserData();
    setLoading(false);
  };

  const deleteState = id => {
    setUserAssignData(prevData => prevData.filter(item => item.id !== id));
  };

  const fetchDeleteData = async Data_id => {
    setLoading(true);
    try {
      await axios.delete(`${API_URL}/api/users/position/${Data_id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      console.error("fetchDeleteData Error:", error);
    }
    setLoading(false);
  };

  const handleKeyDown = e => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const headers = [
    { field: "user_name", label: "ชื่อ-นามสกุล" },
    { field: "user_name_assigned", label: "เข้ารับตำแหน่งข้าราชการแทน" },
    { field: "org_name", label: "สำนัก/กอง/กลุ่ม" },
    { field: "position_name", label: "ตำแหน่ง" },
    { field: "date_start", label: "วันที่ได้รับตำแหน่งแทน" },
    { field: "status", label: "สถานะผู้ใช้งาน" },
  ];

  const handleHeaderClick = (value, index, inversed) => {
    setIndexSort(index);
    setInversedSort(inversed);
    fetchUserData(value, inversed ? "DESC" : "ASC");
  };

  const headerStyles = {
    verticalAlign: "middle",
    whiteSpace: "nowrap",
    cursor: "pointer",
    transition: "background-color 0.3s",
  };

  const sortIcon = index => (
    <i className={`ps-2 ${indexSort === index ? `fa-duotone fa-sort-${inversedSort ? "down" : "up"}` : "text-secondary fa-regular fa-sort"}`}></i>
  );

  const hoverEffect = (e, inOut) => {
    e.target.style.backgroundColor = inOut ? "rgba(215,218,222,0.6)" : "rgba(239,242,247,1)";
  };

  const handleModal = (toggle, id) => {
    setconfirmModal(toggle);
    setId(id);
  };

  useEffect(() => {
    if (userInfo) {
      if (!CheckPosition(userInfo?.position) && !CheckSubAdmin(userInfo?.positionSubAdmin)) {
        navigate("/setdata");
      }
    }
  }, [userInfo]);

  return (
    <Fragment>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
          <LoadingData />
        </div>
      ) : (
        <FadeIn>
          <Row className="mb-3">
            <Col xs={12} md={10} lg={6} className="mt-2">
              <InputGroup>
                <Input
                  type="search"
                  style={{ width: "40%" }}
                  placeholder="...กรุณาใส่คำที่ต้องการค้นหา"
                  value={keyword}
                  onKeyDown={handleKeyDown}
                  onChange={e => setKeyword(e.target.value)}
                />
                <Button style={{ display: "flex", alignItems: "center" }} color="primary" onClick={handleSearch}>
                  <i className="fa-sharp fa-solid fa-magnifying-glass fa-xl"></i>
                </Button>
              </InputGroup>
            </Col>
            <Col xs={12} md={2} lg={6} style={{ display: "flex", justifyContent: "end" }} className="mt-2">
              <AddAssign onButtonClick={handleButtonClick} />
            </Col>
          </Row>

          <Row>
            <Col>
              <Table className="align-middle" striped style={{ overflow: "scroll", fontSize: "15px" }} responsive>
                <thead className="table-light" style={headerStyles}>
                  <tr>
                    <th>ลำดับ</th>
                    {headers.map((header, index) => (
                      <th
                        key={index}
                        onMouseEnter={e => hoverEffect(e, true)}
                        onMouseLeave={e => hoverEffect(e, false)}
                        onClick={() => handleHeaderClick(header.field, index, !inversedSort)}
                      >
                        {header.label}{sortIcon(index)}
                      </th>
                    ))}
                    <th></th>
                  </tr>
                </thead>

                <tbody>
                  {userAssignData.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center fs-5">ไม่มีข้อมูล</td>
                    </tr>
                  ) : (
                    userAssignData.map((user, index) => {
                      let cp = (currentPage - 1) * 10;
                      return (
                        <tr key={index}>
                          <td style={{ fontSize: "16px" }}>{index + cp + 1}</td>
                          <td>{user.user_name}</td>
                          <td>{user.user_name_assigned ?? "รักษาราชการแทน"}</td>
                          <td>
                            {user.org_name === null ? (
                              <td>กรุณากรอกข้อมูลของสำนัก/กอง/กลุ่ม ในการแก้ไข</td>
                            ) : (
                              <td>{user.org_name}</td>
                            )}
                          </td>
                          <td>
                            <td>{user.position_name}</td>
                          </td>
                          <td>
                            {user.date_start === null ? (
                              <td>กรุณากรอกวันที่เริ่ม ในการแก้ไข</td>
                            ) : (
                              <td>
                                {dayjs.utc(user.date_start).add(543, "year").format("DD/MM/YYYY")}
                              </td>
                            )}
                          </td>
                          <td>
                            {user.status === 1 ? (
                              <Badge color="success" className="p-2 bg-opacity-10">
                                <span className="text-success fs-6">ใช้งาน</span>
                              </Badge>
                            ) : (
                              <Badge color="danger" className="p-2 bg-opacity-10">
                                <span className="text-danger fs-6">ไม่ใช้งาน</span>
                              </Badge>
                            )}
                          </td>
                          <td>
                            {user.assign_type === 1 ? (
                              <EditAssign id={parseInt(user.id)} assignID={user.assigned_by_user_id} onButtonClick={handleButtonClick} />
                            ) : user.assign_type === 0 ? (
                              <EditAssignCommander id={parseInt(user.id)} assignID={user.assigned_by_user_id} onButtonClick={handleButtonClick} />
                            ) : (
                              ""
                            )}
                            <Button className="mt-1" color="danger" onClick={() => handleModal(true, user.id)}>
                              <i className="fa-solid fa-trash"></i>
                            </Button>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </Table>

              <Row className="mx-2" style={{ display: "flex", alignItems: "center" }}>
                <Col xxl={4}>
                  <h4 className="mb-0">
                    <Badge className="badge-soft-primary me-1 fs-5">
                      ทั้งหมด {dataInfo?.totalRows} รายการ
                    </Badge>
                  </h4>
                </Col>
                <Col xxl={8} className="d-flex justify-content-center justify-content-sm-end">
                  <Pagination className="mt-3">
                    <PaginationItem disabled={currentPage === 1}>
                      <PaginationLink onClick={() => setCurrentPage(1)}>หน้าแรก</PaginationLink>
                    </PaginationItem>
                    <PaginationItem disabled={currentPage === 1}>
                      <PaginationLink onClick={() => setCurrentPage(currentPage - 1)}>ย้อนกลับ</PaginationLink>
                    </PaginationItem>
                    <PaginationItem active>
                      <PaginationLink>หน้า {currentPage} จาก {totalPages}</PaginationLink>
                    </PaginationItem>
                    <PaginationItem disabled={currentPage === dataInfo.totalPage || totalPages === 0}>
                      <PaginationLink onClick={() => setCurrentPage(dataInfo.currentPage + 1)}>ถัดไป</PaginationLink>
                    </PaginationItem>
                    <PaginationItem disabled={currentPage === totalPages || totalPages === 0}>
                      <PaginationLink onClick={() => setCurrentPage(dataInfo.totalPage)}>หน้าสุดท้าย</PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </Col>
              </Row>
            </Col>
          </Row>

          <ConfirmModal
            modal={confirmModal}
            modalSize="md"
            modalHeaderContent="คุณต้องการที่จะลบ ใช่หรือไม่?"
            onClickConfirmBtn={async () => {
              await fetchDeleteData(id);
              deleteState(id);
              setconfirmModal(false);
            }}
            onClickCancelBtn={() => setconfirmModal(false)}
          />
        </FadeIn>
      )}
    </Fragment>
  );
}

export default AssignCommander;
